














import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'

@Component
export default class OrderDetailsTabs extends Vue {
    @Inject() reloadOrder: () => Promise<void>
    @Prop({ required: true }) readonly order!: Order

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.order || !this.order.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.order.referral.assignedToBranch.company.id
    }

    get isEditable(): boolean {
        if (!this.order.referral || ['processed', 'closed'].includes(this.order.referral.status)) {
            return false
        }

        return true
    }
}

